module.exports = __webpack_public_path__ + "static/image/logo-family/logo_kitchen.png?3a49b0b0";